import * as types from './OthersActionType'
const initialState = {
  userList: [],
  busStationList: [],
  timeTableData:[],
}
const OtherReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.USER_LIST:
      return {
        ...state,
        userList: action.payload
      }
    case types.BUS_STATION_LIST:
      return {
        ...state,
        busStationList: action.payload
      }
    case types.TIME_TABLE_DATA:
      return {
        ...state,
        timeTableData: action.payload
      }

    default:
      return state;
  }
};

export default OtherReducer;
